module.exports = __webpack_public_path__ + "static/img/3.223a36b5.webp";